import { useNavigate } from 'react-router-dom';
import BannerSlider from '../components/BannerSlider';
import { useEffect, useState } from 'react';
import StreamCard from '../components/StreamCard';
import PoolDegenSection from '../components/PoolDegenSection';
import QuestCard from '../components/quests/QuestCard';
import NFTCard from '../components/nft/NFTCard';
import api, { endpoints } from '../utils/apiClient';
import { CubeIcon } from '@heroicons/react/24/outline';

const Home = () => {
  const navigate = useNavigate();
  const [streams, setStreams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('all');
  const [tournaments, setTournaments] = useState([]);
  const [quests, setQuests] = useState([]);
  const [nfts, setNfts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Initialize with mock data
        const mockStreams = [
          {
            _id: '1',
            title: 'Playing Pool Tournament',
            thumbnail: '/banner.png',
            description: 'Join me for an exciting pool tournament!',
            status: 'live',
            viewers: 120,
            creator: { username: 'PoolMaster' }
          },
          {
            _id: '2',
            title: 'Billiards Championship',
            thumbnail: '/banner.png',
            description: 'Final round of the billiards championship',
            status: 'live',
            viewers: 85,
            creator: { username: 'ProPlayer' }
          }
        ];

        const mockTournaments = [
          {
            _id: '1',
            title: 'Weekly Pool Tournament',
            thumbnail: '/banner.png',
            game: 'Pool',
            prize: '1000 BITP',
            participants: Array(5),
            maxParticipants: 16,
            status: 'Registration Open'
          },
          {
            _id: '2',
            title: 'Championship Series',
            thumbnail: '/banner.png',
            game: 'Billiards',
            prize: '5000 BITP',
            participants: Array(8),
            maxParticipants: 8,
            status: 'In Progress'
          }
        ];

        const mockQuests = [
          {
            _id: '1',
            title: 'Win 5 games in a row',
            description: 'Complete this quest by winning 5 consecutive games',
            reward: '50 BITP',
            difficulty: 'Medium',
            type: 'Achievement'
          },
          {
            _id: '2',
            title: 'Score a perfect game',
            description: 'Win a game without missing a single shot',
            reward: '100 BITP',
            difficulty: 'Hard',
            type: 'Challenge'
          }
        ];

        const mockNfts = [
          {
            id: "1",
            name: "BitSport Champion #001",
            description: "Legendary champion with exclusive tournament access",
            image: "/nft/nft-1.jpg",
            rarity: "Legendary",
            price: 0.15,
            currency: "ETH",
            owner: null,
          },
          {
            id: "2",
            name: "BitSport Strategist #042",
            description: "Master strategist with enhanced prediction capabilities",
            image: "/nft/nft-2.jpg",
            rarity: "Epic",
            price: 0.12,
            currency: "ETH",
            owner: null,
          },
          {
            id: "3",
            name: "BitSport Speedster #103",
            description: "Lightning-fast competitor with reaction time bonuses",
            image: "/nft/nft-3.jpg",
            rarity: "Rare",
            price: 0.1,
            currency: "ETH",
            owner: null,
          }
        ];

        try {
          // Try to fetch real data
          const [streamsResponse, tournamentsResponse, questsResponse, collectionsResponse] = await Promise.all([
            api.get(endpoints.streams.list),
            api.get(endpoints.tournaments.list),
            api.get(endpoints.quests.list),
            api.get(endpoints.nft.collections)
          ]);

          console.log('API Response - Tournaments:', tournamentsResponse);
          console.log('API Response - Collections:', collectionsResponse);

          // Use real data if available, otherwise use mock data
          // The apiClient already extracts .data from the response
          const finalTournaments = (tournamentsResponse?.tournaments || mockTournaments).slice(0, 3);
          console.log('Setting Tournaments State:', finalTournaments);

          setStreams(streamsResponse || mockStreams);
          setTournaments(finalTournaments);
          setQuests((questsResponse || mockQuests).slice(0, 3));

          // Handle NFT data
          if (collectionsResponse && collectionsResponse.length > 0) {
            // Get the first active collection
            const activeCollection = collectionsResponse.find(c => c.status === 'active') || collectionsResponse[0];
            console.log('Found active collection:', activeCollection);

            try {
              // Fetch NFTs for this collection
              const nftsResponse = await api.get(endpoints.nft.nfts(activeCollection._id));
              console.log('API Response - NFTs:', nftsResponse);

              if (nftsResponse && nftsResponse.length > 0) {
                console.log('Setting real NFTs:', nftsResponse.slice(0, 3));
                setNfts(nftsResponse.slice(0, 3));
              } else if (nftsResponse && nftsResponse.data && nftsResponse.data.length > 0) {
                console.log('Setting real NFTs from data property:', nftsResponse.data.slice(0, 3));
                setNfts(nftsResponse.data.slice(0, 3));
              } else {
                console.log('No NFTs found, showing empty state');
                setNfts([]);
              }
            } catch (nftError) {
              console.warn('Error fetching NFTs:', nftError);
              setNfts([]);
            }
          } else if (collectionsResponse && collectionsResponse.data && collectionsResponse.data.length > 0) {
            // Alternative response format
            const activeCollection = collectionsResponse.data.find(c => c.status === 'active') || collectionsResponse.data[0];
            console.log('Found active collection (from data property):', activeCollection);

            try {
              // Fetch NFTs for this collection
              const nftsResponse = await api.get(endpoints.nft.nfts(activeCollection._id));
              console.log('API Response - NFTs:', nftsResponse);

              if (nftsResponse && nftsResponse.length > 0) {
                console.log('Setting real NFTs:', nftsResponse.slice(0, 3));
                setNfts(nftsResponse.slice(0, 3));
              } else if (nftsResponse && nftsResponse.data && nftsResponse.data.length > 0) {
                console.log('Setting real NFTs from data property:', nftsResponse.data.slice(0, 3));
                setNfts(nftsResponse.data.slice(0, 3));
              } else {
                console.log('No NFTs found, showing empty state');
                setNfts([]);
              }
            } catch (nftError) {
              console.warn('Error fetching NFTs:', nftError);
              setNfts([]);
            }
          } else {
            console.log('No collections found, showing empty state');
            setNfts([]);
          }
        } catch (apiError) {
          console.warn('API error, showing empty state for NFTs:', apiError); // <-- IMPROVED LOGGING
          setStreams(mockStreams);
          setTournaments(mockTournaments.slice(0, 3)); // Ensure mock data is set on API error
          setQuests(mockQuests.slice(0, 3));
          setNfts([]); // Show empty state for NFTs
          console.log('Using empty state for NFTs due to API error');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
        setError(err.message || 'Failed to load content');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filteredStreams = streams.filter(stream => {
    switch (activeTab) {
      case 'live':
        return stream.status === 'live';
      case 'scheduled':
        return stream.status === 'scheduled' || stream.isScheduled;
      default:
        return true;
    }
  });

  return (
    <div className="p-6">
      <BannerSlider />
      <PoolDegenSection />

      {/* BitPool AI Agent Section */}
      <div className="mt-12">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">BitPool AI Agent</h2>
          <button
            onClick={() => navigate('/bitpool-ai-agent')}
            className="text-purple-500 hover:text-purple-400"
          >
            View All
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {quests.map((quest) => (
            <QuestCard key={quest._id} quest={quest} />
          ))}
          {quests.length === 0 && !loading && (
            <div className="col-span-3 text-center text-gray-400 py-8">
              No active quests available
            </div>
          )}
        </div>
      </div>

      {/* Streams Section */}
      <div className="mt-12">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">BitSport Live</h2>
          <div className="flex gap-4">
            <button
              onClick={() => setActiveTab('all')}
              className={`px-4 py-2 rounded-lg transition-colors ${
                activeTab === 'all'
                  ? 'bg-purple-600 text-white'
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              All Streams
            </button>
            <button
              onClick={() => setActiveTab('scheduled')}
              className={`px-4 py-2 rounded-lg transition-colors ${
                activeTab === 'scheduled'
                  ? 'bg-purple-600 text-white'
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              Scheduled
            </button>
          </div>
        </div>
        {loading && <div className="text-center text-gray-400">Loading streams...</div>}
        {error && <div className="text-center text-red-500 p-4 bg-red-900/20 rounded-lg">{error}</div>}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredStreams.map((stream) => (
            <StreamCard key={stream._id} stream={stream} creator={stream.creator} />
          ))}
          {filteredStreams.length === 0 && !loading && (
            <div className="col-span-3 text-center text-gray-400 py-8">
              No streams available
            </div>
          )}
        </div>
      </div>

      {/* NFT Collection Section */}
      <div className="mt-12">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold flex items-center">
            <CubeIcon className="h-6 w-6 mr-2 text-violet-500" />
            Immutable NFT Collection
          </h2>
          <button
            onClick={() => navigate('/nft-collection')}
            className="text-purple-500 hover:text-purple-400"
          >
            View All
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {nfts.map((nft) => (
            <NFTCard
              key={nft._id || nft.id}
              nft={nft}
              showQuickView={false} // Don't show Quick View button on homepage
            />
          ))}
          {nfts.length === 0 && !loading && (
            <div className="col-span-3 text-center text-gray-400 py-8">
              No NFTs available
            </div>
          )}
        </div>
      </div>

      {/* Tournaments Section */}
      <div className="mt-12">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">Featured Tournaments</h2>
          <button
            onClick={() => navigate('/tournaments')}
            className="text-purple-500 hover:text-purple-400"
          >
            View All
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tournaments.map((tournament) => (
            <div
              key={tournament._id}
              onClick={() => navigate(`/tournament/${tournament._id}`)}
              className="bg-gray-900 rounded-lg overflow-hidden hover:ring-2 hover:ring-purple-500 transition-all cursor-pointer"
            >
              <img src={tournament.thumbnail} alt={tournament.title} className="w-full h-48 object-cover" />
              <div className="p-4">
                <h3 className="text-lg font-semibold text-white mb-2">{tournament.title}</h3>
                <div className="space-y-2 text-sm text-gray-400">
                  <p className="flex justify-between">
                    <span>Game:</span>
                    <span className="text-white">{tournament.game}</span>
                  </p>
                  <p className="flex justify-between">
                    <span>Prize Pool:</span>
                    <span className="text-green-400">{tournament.prize}</span>
                  </p>
                  <p className="flex justify-between">
                    <span>Participants:</span>
                    <span className="text-white">{tournament.participants?.length || 0}/{tournament.maxParticipants}</span>
                  </p>
                  <div className="pt-2">
                    <span className={`px-2 py-1 rounded text-xs ${tournament.status === "Registration Open" ? "bg-green-500/20 text-green-400" : "bg-red-500/20 text-red-400"}`}>
                      {tournament.status}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {tournaments.length === 0 && !loading && (
            <div className="col-span-3 text-center text-gray-400 py-8">
              No tournaments available
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
